import { app } from '../../../../bootstrap/core';
import { chartDiagramComponent } from './chartDiagram.component';
import ChartDiagramDirective from './chartDiagram.directive';

app
  .component('chartDiagram', chartDiagramComponent)
  .directive('chartDiagramBlock', () => new ChartDiagramDirective);
